<div class="add-eoi">
    <!--    <div class="title">EOIs</div>-->
    <div (click)="back()" fxLayout="row" style="margin-bottom: 16px">
        <mat-icon>chevron_left</mat-icon>
        <div class="back">Back</div>
    </div>

    <div *ngIf="eoiDetail">
        <div class="title-grid">
            <div fxLayout="row">
                <div class="eoi-no">EOI No.{{eoiDetail.eoiNo}}</div>
                <span class="status" style="background: #FFF3D2;color: #FFAF13"
                    *ngIf="eoiDetail.status == 'PENDING'">{{eoiDetail.status}}
                </span>
                <span class="status" style="background: #DCFFE6;color: #00E15A"
                    *ngIf="eoiDetail.status == 'APPROVED'">{{eoiDetail.status}}
                </span>
                <span class="status" style="background: #FFE7E2;color: #FF5C00"
                    *ngIf="eoiDetail.status == 'REJECTED'">{{eoiDetail.status}}
                </span>
                <span class="status" style="background: #FFE7E2;color: #FF5C00"
                    *ngIf="eoiDetail.status == 'WITHDRAW'">{{eoiDetail.status}}
                </span>
                <span class="status" style="background: #FFE7E2;color: red"
                    *ngIf="eoiDetail.status == 'REMOVED'">{{eoiDetail.status}}
                </span>
            </div>
            <div class="time" fxLayout="row">
                <div *ngIf="eoiDetail.status == 'PENDING'">Submitted on&nbsp;&nbsp;</div>
                <div *ngIf="eoiDetail.status != 'PENDING'">Processed on&nbsp;&nbsp;</div>
                <div *ngIf="eoiDetail.status == 'PENDING'">{{eoiDetail.createTime | date: 'h:mm:ss dd/MM/yyyy'}}</div>
                <div *ngIf="eoiDetail.status != 'PENDING'">{{eoiDetail.processTime | date: 'h:mm:ss dd/MM/yyyy'}}</div>
            </div>
        </div>
        <mat-divider></mat-divider>
        <div class="value-grid">
            <div fxLayout="row">
                <div fxLayout="row" style="width: 50%;display: flex;justify-content: space-between">
                    <div class="label">Primary Buyer</div>
                    <div style="text-align: start;width: 50%;">
                        <div>{{eoiDetail.buyer.firstName}}&nbsp;{{eoiDetail.buyer.middleName != 'undefined' ?
                            eoiDetail.buyer.middleName : ''}}{{eoiDetail.buyer.lastName}}</div>
                        <div class="txt">{{eoiDetail.buyer.phoneNumber}}</div>
                        <div class="txt">{{eoiDetail.buyer.email}}</div>
                        <div class="txt">{{eoiDetail.buyer.addressLine1}}
                            ,{{eoiDetail.buyer.area}} {{eoiDetail.buyer.state}} {{eoiDetail.buyer.postCode}}</div>
                    </div>
                </div>
                <div style="width: 50%;">
                    <div fxLayout="row" style="display: flex;justify-content: space-between;margin-bottom: 10px">
                        <div style="padding: 0 20%" class="label">Payment Receipt</div>
                        <div *ngIf="eoiDetail.receipt" fxLayout="row">
                            <div>{{eoiDetail.receipt.fileName}}</div>
                            <mat-icon style="font-size: 22px;color:#556EE6;cursor: pointer;"
                                (click)="openReceiptFile(eoiDetail.receipt.fileName)">launch
                            </mat-icon>

                        </div>
                    </div>
                    <div fxLayout="row" style="display: flex;justify-content: space-between">
                        <div style="padding: 0 20%" class="label">EOI Form</div>
                        <div *ngIf="eoiDetail.eoiForm" fxLayout="row">
                            <div>{{eoiDetail.eoiForm.fileName}}</div>
                            <mat-icon style="font-size: 22px;color:#556EE6;cursor: pointer;"
                                (click)="openEoiFile(eoiDetail.eoiForm.fileName)">launch
                            </mat-icon>
                        </div>
                    </div>
                </div>
            </div>
            <div fxLayout="row" style="margin-top: 17px">
                <div fxLayout="row" style="width: 50%;display: flex;justify-content: space-between">
                    <ng-container *ngIf="eoiDetail.agent">
                        <div class="label">Agent</div>
                        <div style="text-align: start;width: 50%;">
                            <div fxLayout="row">
                                <img style="width: 25px"
                                    src="{{SERVER_URL}}images/user_{{eoiDetail.agent.id}}/{{eoiDetail.agent.headerUrl}}">
                                <div>{{ eoiDetail.agent.firstName }}{{ eoiDetail.agent.lastName }}</div>
                            </div>
                            <div class="txt">{{agentMobile}}</div>
                            <div class="txt">{{agentEmail}}</div>
                        </div>
                    </ng-container>
                </div>
                <div style="width: 50%;" *ngIf="eoiDetail.status == 'REJECTED'||eoiDetail.status == 'REMOVED'">
                    <div fxLayout="row" style="display: flex;justify-content: space-between;margin-bottom: 10px">
                        <div style="padding: 0 20%" class="label">Reject reason</div>
                        <div class="reason" *ngIf="!eoiDetail.rejectReason">
                            The application is removed because...
                        </div>
                        <div class="reason" *ngIf="eoiDetail.rejectReason">
                            {{ eoiDetail.rejectReason }}
                        </div>
                    </div>
                </div>
            </div>

            <div fxLayout="row" style="margin-top: 17px">
                <div fxLayout="row" style="width: 50%;display: flex;justify-content: space-between"
                    *ngIf="eoiDetail.agency">
                    <div class="label">Agency</div>
                    <div style="text-align: start;width: 50%;">
                        <div fxLayout="row">
                            <div *ngIf="eoiDetail.agency.logo.fileName">
                                <img style="width: 25px"
                                    src="{{SERVER_URL}}images/company_{{eoiDetail.agency.id}}/{{eoiDetail.agency.logo.fileName}}">
                            </div>

                            <div> {{eoiDetail.agency.logo.fileName}} 11111 {{ eoiDetail.agency.name }}</div>
                        </div>
                        <div class="txt">{{eoiDetail.agency.phoneNumber}}</div>
                    </div>
                </div>
                <div style="width: 50%;"></div>
            </div>
        </div>

        <div fxLayout="row" fxLayoutGap="20px" style="display:flex;margin-top: 20px;justify-content: end">
            <button *ngIf="eoiDetail.status == 'PENDING'" mat-flat-button style="background: #03BC79;color: #fff"
                (click)="approve()">
                <mat-icon>done</mat-icon>
                Approve
            </button>
            <button *ngIf="eoiDetail.status == 'PENDING'" mat-flat-button style="background: #EA5050;color: #fff"
                (click)="reject()">
                <mat-icon>clear</mat-icon>
                Reject
            </button>
            <button *ngIf="eoiDetail.status == 'APPROVED'" mat-flat-button
                style="background: rgba(53, 41, 66, 0.1);color: #352942" (click)="remove()">
                <mat-icon>delete</mat-icon>
                Remove
            </button>
        </div>
    </div>
</div>